import React, { useState } from "react";
import { Box, Button, Modal, RadioGroup, SpaceBetween } from "@amzn/awsui-components-react";

/**
 * Reusable modal component for selecting download format (PDF vs Excel).
 * 
 * Props:
 * - visible (boolean): Whether the modal is shown
 * - onDismiss (function): Called when the modal is dismissed/cancelled
 * - onConfirm (function): Called with the selected format ("pdf" or "excel") when confirmed
 * - description (string, optional): Custom description text for the modal
 */
const DownloadFormatModal = ({ visible, onDismiss, onConfirm, description }) => {
  const [selectedFormat, setSelectedFormat] = useState("pdf");

  const handleConfirm = () => {
    onConfirm(selectedFormat);
  };

  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      header="Download Format"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button onClick={onDismiss} variant="link">Cancel</Button>
            <Button variant="primary" onClick={handleConfirm}>Download</Button>
          </SpaceBetween>
        </Box>
      }
    >
      <SpaceBetween direction="vertical" size="m">
        <Box>{description || "Select the format for your download:"}</Box>
        <RadioGroup
          value={selectedFormat}
          onChange={({ detail }) => setSelectedFormat(detail.value)}
          items={[
            { value: "pdf", label: "PDF", description: "Download as PDF (opens print dialog)" },
            { value: "excel", label: "Excel", description: "Download as Excel spreadsheet (.xlsx)" }
          ]}
        />
      </SpaceBetween>
    </Modal>
  );
};

export default DownloadFormatModal;
